module.exports = __webpack_public_path__ + "img/faq.bb1513d6.svg";